import { createFileRoute } from '@tanstack/react-router'
import FeedbacksPage from '../pages/FeedbacksPage/FeedbacksPage'

interface FeedbacksSearch {
  ticket?: number
}

export const Route = createFileRoute('/feedbacks')({
  validateSearch: (search: Record<string, unknown>): FeedbacksSearch => {
    const raw = search.ticket
    const ticket =
      typeof raw === 'number'
        ? raw
        : typeof raw === 'string' && raw.trim() !== ''
          ? Number(raw)
          : undefined
    return ticket !== undefined && !Number.isNaN(ticket) ? { ticket } : {}
  },
  component: FeedbacksPage,
})
